import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface Office {
  id: string;
  city: string;
  address: string;
  email: string;
  hours: string;
  lat: number;
  lng: number;
}

interface OfficeLocationsProps {
  className?: string;
}

const OfficeLocations = ({ className = '' }: OfficeLocationsProps) => {
  const offices: Office[] = [
    {
      id: '1',
      city: 'UK Office',
      address: 'First Floor Office, 3 Hornton Place, London, W8 4LZ, UNITED KINGDOM',
      email: 'info@consultintech.com',
      hours: 'Mon-Fri: 9:00 AM - 6:00 PM GMT',
      lat: 51.5074,
      lng: -0.1278
    }
  ];

  return (
    <section className={`py-16 bg-card ${className}`}>
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-display font-bold text-foreground mb-4">
            Our Office Location
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Visit us at our UK office or schedule a virtual meeting. We're here to support your digital transformation journey.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {offices.map((office) => (
            <div
              key={office.id}
              className="bg-background rounded-lg overflow-hidden shadow-subtle hover:shadow-elevation transition-all duration-300"
            >
              <div className="h-48 w-full overflow-hidden">
                <iframe
                  width="100%"
                  height="100%"
                  loading="lazy"
                  title={office.city}
                  referrerPolicy="no-referrer-when-downgrade"
                  src={`https://www.google.com/maps?q=${office.lat},${office.lng}&z=14&output=embed`}
                  className="border-0"
                ></iframe>
              </div>
              <div className="p-6 space-y-4">
                <h3 className="text-xl font-display font-semibold text-foreground">
                  {office.city}
                </h3>
                <div className="space-y-3">
                  <div className="flex items-start space-x-3">
                    <Icon name="MapPinIcon" size={20} className="text-primary flex-shrink-0 mt-0.5" />
                    <p className="text-sm text-muted-foreground">{office.address}</p>
                  </div>
                  <div className="flex items-center space-x-3">
                    <Icon name="EnvelopeIcon" size={20} className="text-primary flex-shrink-0" />
                    <p className="text-sm text-foreground font-medium">{office.email}</p>
                  </div>
                  <div className="flex items-start space-x-3">
                    <Icon name="ClockIcon" size={20} className="text-primary flex-shrink-0 mt-0.5" />
                    <p className="text-sm text-muted-foreground">{office.hours}</p>
                  </div>
                </div>
                <button className="w-full mt-4 py-2 px-4 border-2 border-primary text-primary rounded-md text-sm font-semibold hover:bg-primary hover:text-primary-foreground transition-all duration-300">
                  Get Directions
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default OfficeLocations;